module.exports = __webpack_public_path__ + "static/media/sarajevo_back.320f9604.jpg";